import {Component} from './component';

const csrfToken = document
    .querySelector('meta[name=token]')
    .getAttribute('content');
const stopStreamResponse = async reader => {
    if (reader) {
        await reader.cancel();
        reader = null;
    }
};

const chatSendIcon = `
<svg style="width:18px; height:18px;" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"></path>
</svg>
`;

const stopIcon = `
<svg style="width:22px; height:22px"  viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"></path>
</svg>
`;

const aiMessagePlaceholder = `
  <div class="ai-message-wrapper d-flex">
    <div class="d-flex chat-message ai-message">
      <div class="chat-message-placeholder"><span class="jumping-dots d-flex"><span>.</span><span>.</span><span>.</span></span></div>
    </div>
  </div>
`;

export class GlobalSearchChat extends Component {

    async setup() {
        this.chatWrapper = this.$el;
        this.chatMessagesWrapper = this.$refs.aiSearchChatMessagesWrapper;
        this.form = this.$refs.form;
        this.input = this.$refs.input;
        this.searchInput = document.querySelector('#header-search-box-input');
        this.sendBtn = this.$refs.sendBtn;
        this.stopBtn = this.$refs.stopBtn;
        this.chatHistory = [];

        this.aiMessagePlaceholder = document.createElement('div');
        this.aiMessagePlaceholder.innerHTML = aiMessagePlaceholder;
        this.aiMessagePlaceholder.classList.add('ai-message-wrapper');
        this.aiMessagePlaceholder.classList.add('d-flex');

        this.sendBtn.innerHTML = chatSendIcon;
        this.stopBtn.innerHTML = stopIcon;

        this.setupListeners();
    }

    setupListeners() {
        this.form.addEventListener('submit', event => {
            event.preventDefault();
            this.sendUserMessage(this.input.value);
            this.input.value = '';
        });

        document.addEventListener('ai-search', async () => {
            this.chatWrapper.classList.add('d-none');
            await stopStreamResponse(this.reader);
            this.chatMessagesWrapper.innerHTML = '';
            this.form.classList.remove('d-none');
        });

        document.addEventListener('ai-search-done', async () => {
            this.chatWrapper.classList.remove('d-none');
        });

        this.stopBtn.addEventListener('click', () => {
            stopStreamResponse(this.reader);
        });

        this.searchInput.addEventListener('input', async (e) => {
            if (e.target.value.length === 0) { 
                this.chatWrapper.classList.add('d-none');
                this.form.classList.add('d-none');
                await stopStreamResponse(this.reader);
                this.chatMessagesWrapper.innerHTML = '';
            }
        });
    }

    addAiResponse(response = '') {
        const responseWrapper = document.createElement('div');
        responseWrapper.classList.add('ai-message-wrapper');
        responseWrapper.innerHTML = '<div class="chat-message ai-message"></div>';
        const chatTextElement = document.createElement('div');
        chatTextElement.classList.add('chat-message-text');
        chatTextElement.innerHTML = response;

        const aiMessageEl = responseWrapper.querySelector('.ai-message');
        aiMessageEl.appendChild(chatTextElement);

        this.chatMessagesWrapper.appendChild(responseWrapper);
        this.chatMessagesWrapper.scrollTo(
            0,
            this.chatMessagesWrapper.scrollHeight,
        );

        return aiMessageEl;
    }

    editAiResponse(aiMessageEl, response) {
        aiMessageEl.innerHTML = response;
        this.chatMessagesWrapper.scrollTo(
            0,
            this.chatMessagesWrapper.scrollHeight,
        );
    }

    addUserMessage(message) {
        const messageElement = document.createElement('div');
        messageElement.classList.add('user-message-wrapper');
        messageElement.innerHTML = `
        <div class="chat-message user-message">
          <div class="chat-message-text">${message}</div>
        </div>
      `;
        this.chatMessagesWrapper.appendChild(messageElement);
    }

    async sendUserMessage(message) {
        this.addUserMessage(message);
        const context = this.chatWrapper
            .closest('.ai-answer-body')
            .querySelector('.ai-answer-content').innerHTML;
        const aiResponse = await this.askAi(message, context);

        this.chatHistory.push({author: 'user', content: message});
        this.chatHistory.push({author: 'ai', content: aiResponse});
    }

    async askAi(message) {
        await stopStreamResponse(this.reader);
        this.input.setAttribute('disabled', 'disabled');
        this.sendBtn.setAttribute('disabled', 'disabled');
        const context = document.querySelector('.ai-answer-content').innerHTML;

        this.addAiMessagePlaceholder();

        const response = await fetch(
            `${window.location.origin}/ai/search-ai-chat`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify({
                    context,
                    message,
                    chatHistory: JSON.stringify(this.chatHistory.slice(-10)),
                }),
            },
        );
        await stopStreamResponse(this.reader);
        this.reader = response.body.getReader();
        this.toggleInputButtons();
        this.removeAiMessagePlaceholder();
        const aiResponseEl = this.addAiResponse();
        const decoder = new TextDecoder();

        let res = '';
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // eslint-disable-next-line no-await-in-loop
            const {done, value} = await this.reader.read();

            if (done) {
                this.input.removeAttribute('disabled');
                this.input.focus();
                this.sendBtn.removeAttribute('disabled');
                this.toggleInputButtons();
                break;
            }

            res += decoder.decode(value);
            this.editAiResponse(aiResponseEl, res);
        }
        return res;
    }

    addAiMessagePlaceholder() {
        this.chatMessagesWrapper.appendChild(this.aiMessagePlaceholder);
        this.chatMessagesWrapper.scrollTo(
            0,
            this.chatMessagesWrapper.scrollHeight,
        );
    }

    removeAiMessagePlaceholder() {
        if (this.aiMessagePlaceholder
            && this.chatMessagesWrapper
            && this.chatMessagesWrapper.contains(this.aiMessagePlaceholder)) {
            this.chatMessagesWrapper.removeChild(this.aiMessagePlaceholder);
        }
        this.chatMessagesWrapper.scrollTo(
            0,
            this.chatMessagesWrapper.scrollHeight,
        );
    }

    toggleInputButtons() {
        this.stopBtn.classList.toggle('d-none');
        this.sendBtn.classList.toggle('d-none');
    }

}
